/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// --- Begin video section
window.addEventListener('load', function () {
  if (document.querySelector('.section-video-banner')) {
    window.addEventListener(
      'resize',
      debounce(function (e) {
        loadVideo()
      })
    )
    loadVideo()
  } 
})

function loadVideo() {
  let needsLoad = false
  let selector = null

  if (window.matchMedia('(min-width: 640px)').matches) {
    /* the viewport is at least 640 pixels wide */
    selector = '#video__banner__desktop'
  } else {
    /* the viewport is less than 640 pixels wide */
    selector = '#video__banner__mobile'
  }

  const videoElement = document.querySelector(selector)
  const srcElements = videoElement.children

  for (let srcElement of srcElements) {
    if (!srcElement.src) {
      srcElement.src = srcElement.getAttribute('data-src')
      needsLoad = true
    }
  }

  videoElement.addEventListener('loadeddata', (e) => {
    videoElement.classList.add('ready')
    //Video should now be loaded but we can add a second check
    if (videoElement.readyState >= 3) {
      if (!videoElement.classList.contains('ready'))
        videoElement.classList.add('ready')
    }
  })

  if (needsLoad) videoElement.load()
}


// --- End video section


// --- Add to cart within product card
function initBuyButtons() {
  const buyButtons = document.querySelectorAll('[data-buy-button]:not([data-buy-button="listening"]')

  buyButtons.forEach(function(button) {
    button.addEventListener('click', addProductToCart)
    button.setAttribute('data-buy-button', 'listening')
  })
}

function addProductToCart(e) {
	e = e || window.event;
  e.preventDefault();
  var el = e.target

  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'quantity': 1
      }
    ]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((resp) => { 
    return resp.json();
  })
  .then((data) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));
  })
  .catch((err) => {
    console.error('Error: ' + err);
  })
}

initBuyButtons()


// --- End add to cart within product card


document.addEventListener('recommendations:loaded', function(event) {
  initBuyButtons()
});


document.addEventListener('recent:loaded', function(event) {
  initBuyButtons()
});







// --- Utils

function debounce(func) {
  var timer
  return function (event) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, 100, event)
  }
}
